import { customFetch } from "@workspace/api-client-react";

export async function apiFetch<T = unknown>(path: string, options: RequestInit = {}): Promise<T> {
  return customFetch<T>(`/api${path}`, options);
}
